<template>
    <component
        :is="layoutComponent"
        v-if="layoutComponent"
    >
        <router-view />
    </component>
    <router-view v-else />

    <!-- The overlay leaves the app mounted, so in-progress edits survive. -->
    <MaintenanceOverlay />
    <UpdateRequiredDialog />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import AuthLayout from '@/auth/AuthLayout.vue';
import MarketingLayout from '@/marketing/MarketingLayout.vue';
import MaintenanceOverlay from '@/shared/components/MaintenanceOverlay.vue';
import UpdateRequiredDialog from '@/shared/components/UpdateRequiredDialog.vue';
import { useAppStore } from '@/shared/store';

// Registers the deploy-handshake handlers on the shared HTTP client.
useAppStore().installHandshake();

const route = useRoute();

// Per-page <title> and description from route meta; baked at prerender.
useHead({
    title: () => route.meta.title ?? 'Studoku',
    meta: [
        {
            name: 'description',
            content: () => route.meta.description,
        },
    ],
});

const layoutComponent = computed(() => {
    const layoutName = route.meta.layout;

    switch (layoutName) {
        case 'marketing':
            return MarketingLayout;
        case 'auth':
            return AuthLayout;
        case 'default':
        default:
            return null; // Let individual routes handle their own layouts
    }
});
</script>

<style>
* {
    box-sizing: border-box;
}

body,
html,
#app {
    width: 100%;
    height: 100%;
}

ol {
    margin-left: 1.5rem;
}
</style>
